import TranslatesContent from "../DataStore/Languages/translatesContent";
var moment = require("moment"); // require


export const DepositMenu = [
    //for remove upi payment

  {
    name: <TranslatesContent contentKey="bank-payment" />,
    //for remove upi payment
    // pill: "profile",
    pill: "bank",
    image: "inner-tab-icon-2-white.png",
  },
    {
    name: <TranslatesContent contentKey="upi-payment" />,
    pill: "home",
    image: "inner-tab-icon-1.png",
  },
  // {
  //   name: "Crypto Payment",
  //   pill: "crypto",
  //   image: "inner-tab-icon-3.png",
  // },
  {
    name: "QR Payment",
    pill: "QR",
    image: "inner-tab-icon-6-white.png",
  },
  {
    name: "Credit Card",
    pill: "messages",
    image: "inner-tab-icon-3-white.png",
  },
  {
    name: <TranslatesContent contentKey="by-hand" />,
    pill: "settings",
    image: "inner-tab-icon-4-white.png",
  },
  {
    name: <TranslatesContent contentKey="redeposit" />,
    pill: "redeposit",
    image: "inner-tab-icon-7-white.png",
  },


];

//cashier top menu
export const cashierTopMenu = [
  {
    name: <TranslatesContent contentKey="deposit-simple" />,
    pill: "home",
  },
  {
    name: <TranslatesContent contentKey="withdrawal-sim" />,
    pill: "profile",
  },
  {
    name: <TranslatesContent contentKey="transaction-sim" />,
    pill: "contact",
  },
  {
    name: <TranslatesContent contentKey="fund-transfer-profile" />,
    pill: "transfer",
  },
];

export const fundTransferTypes = {
  1: {
    2: {
      url: "sportBetting/sp_transaction/",
      type: "deposit",
    },
    // 3: {
    //   url: "rummy/credit",
    //   type: "",
    // },
  },
  2: {
    1: {
      url: "sportBetting/sp_transaction/",
      type: "withdrawal",
    },
  },
  // 3: {
  //   1: {
  //     url: "rummy/debit",
  //     type: "",
  //   },
  // },
};

//redeposit sample
export const redeposit = {
  withdraw_method: 1,
  witdrowCheck: "off",
  redepositChk: "on",
  redeposit: 0,
};
//transaction history
export const transactionHistory = {
  startDate: moment().format('YYYY-MM-DD')+` 00:00:00`,
  endDate: moment().format('YYYY-MM-DD')+` 23:59:00`,
  type: "",
  cr_db: "*",
};
export const transactionHistory2 = {
  startDate: "2020-06-14 18:20:02",
  endDate: "2022-06-14 18:20:02",
  type: "",
  cr_db: "*",
};
export const TOAST_CONFIG = { position: "top-center", theme: "dark" };

export const GameHistoryMenu = [
  {
    name: "Baccarat",
    key: "baccarat",
    gameID: "BAC",
    pill: "baccarat",
    image: "tab-icon-hitory-baccarat.png",
  },
  {
    name: "Roulette",
    key: "roullete",
    gameID: "ROU",
    pill: "roullete",
    image: "tab-icon-history-roulette.png",
  },
  {
    name: "Andar Bahar",
    key: "andarBahar",
    gameID: "AND",
    pill: "andarBahar",
    image: "tab-icon-history-andar-bahar.png",
  },
  {
    name: "Dragon Tiger",
    key: "dragonTiger",
    gameID: "DRT",
    pill: "dragonTiger",
    image: "tab-icon-5.png",
  },
  {
    name: "Lucky 7",
    key: "lucky7",
    gameID: "LU7",
    pill: "lucky7",
    image: "tab-icon-history-L7.png",
  },
];
export const BOARD_SELECT_COIN = {
  DRT: {
    t: "tiger_coin",
    d: "dragon_coin",
    tie: "tie_coin",
  },
  LU7: {
    '7u': "l7up_coin",
    '7d': "l7down_coin",
    '7l': "l7_coin",
    'black': "black_coin",
    'red': "red_coin",
    'odd': "odd_coin",
    'even': "even_coin",
  },
  AND: {
    'af': "player_coin_andar1",
    'as': "player_coin_andar2",
    'bf': "player_coin_bahar1",
    'bs': "player_coin_bahar2",
  },
  BAC: {
    'pp': "p_pair_coin",
    'ss': "super_six_coin",
    'bp': "b_pair_coin",
    'p': "player_coin",
    't': "tie_coin",
    'bs': "banker_coin",
  },
};
export const CONTACT_DETAILS = {
  withdrow: {
    whatsapp: "+94772764685",
    telegram: "+94772764685"
  },
  deposit: {
    // whatsapp: "+94765992992",
    whatsapp: "+94777067064",
    telegram: "+94762555666"
  },
  other: {
    whatsapp: "+94740607917",
    telegram: "+94740607917"
  }
}